import styles from './Header.module.css';
import {useNavigate} from "react-router-dom";
import React, {useContext, useEffect, useState} from "react";
import {AuthContext} from "../../utils/contextapi/AuthProvider";
import {ModalContext} from "../../utils/modal/ModalProvider";
import moment from "moment/moment";
import {useQuery} from "react-query";
import axios from "../../utils/api/axios";
import {IAM_PATH} from "../../utils/Config";
import {DialogEnum, showDialog} from "../../utils/dialog/Dialog";
import {ServiceUserDetailModal} from "./modal/UserDetailModal";
import DetailModal from "../../utils/modal/DetailModal";

/**
 * 관리도구 Header Container
 * @returns {JSX.Element}
 * @constructor
 */
function Header() {

    const movePage = useNavigate();
    const {saveToken, saveAuthenticated, tokenExpiresIn, saveTokenExpiresIn, saveRole, user, role} = useContext(AuthContext);
    const { openModal, modals, closeModal } = useContext(ModalContext);

    // 토큰 만료 시 로그아웃
    const [tokenExpiredTime, setTokenExpiredTime] = useState({
        minute: moment().minutes(),
        second: moment().second()
    });

    const [userInfo, setUserInfo] = useState({
        id : sessionStorage.getItem("id"),
        userId: sessionStorage.getItem("userId"),
        userName: sessionStorage.getItem("userName"),
        groupId: sessionStorage.getItem("groupId"),
        groupName: sessionStorage.getItem("groupName"),
        role: sessionStorage.getItem("role")
    })

    const {minute, second} = tokenExpiredTime;
    const [sessionIntervalStatus, setSessionIntervalStatus] = useState(true);
    const [idToNameMap, setIdToNameMap] = useState({});
    
    useEffect(() => {
        const key = userInfo.groupId
        const val = userInfo.groupName
        const map = {key, val}
        setIdToNameMap(map)
    }, [])

    useQuery("logout", () => {
    }, {
        enabled: sessionIntervalStatus,
        refetchInterval: 1000
    });

    function sessionLogout() {
        const params = {
            userId: sessionStorage.getItem('userId')
        };

        axios.post(IAM_PATH + '/rest/logout', params)
            .then(res => {
                if(res.data.code == 200){
                    sessionStorage.clear();
                    setUserInfo(null);
                    showDialog(DialogEnum.SUCCESS, "로그아웃 성공", "로그아웃 되었습니다.", movePage('/login', { replace: true }));
                }else {
                    showDialog(DialogEnum.FAIL, "로그아웃 실패", res.data.message);
                }
            }).catch((e) => {
                console.error(e);
                showDialog(DialogEnum.DEFAULT, "로그아웃 실패", e);
            });
    }

    const handleUpdateUserInfo = (() => {
        const modalContent = <ServiceUserDetailModal id={userInfo.id} idToNameMap={idToNameMap} />
                const modalOption = {modalTitle: '상세 정보'}
                openModal(<DetailModal content={modalContent} option={modalOption} />)
    });

    return (
        <section className={styles.rightCont__header}>
            <div className={styles.rightCont__header__mark}>
                {/* <p className={styles.rightCont__header__name}>고객관리 시스템</p> */}
                <div className={styles.rightCont__header__logo}>
                    <img src='/logo_small.png'/>
                </div>
            </div>
            <div className={styles.rightCont__header__user}>
                <span onClick={handleUpdateUserInfo}>
                    <div className={styles.rightCont__header__user}>
                        <img className={styles.rightCont__header__userLink} src='/user_exImg.png'/>
                        <p className={styles.rightCont__header__username}>
                            {userInfo.userId} ({userInfo.role == "SYS_ADMIN" ? "시스템 관리자" : "계정 관리자"})
                        </p>
                    </div>
                </span>
                <button className={styles.leftCont__logout} onClick={sessionLogout}/>
            </div>
        </section>
    )
}

export default Header;